async function apiJson(path, options = {}) {
  const res = await fetch(path, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || `API error ${res.status}`);
    err.status = res.status;
    err.code = data.code;
    throw err;
  }
  return data;
}

export function fetchWidgets() {
  return apiJson('/api/v1/widgets').then((d) => d.widgets);
}

export function fetchWidgetById(id) {
  return apiJson(`/api/v1/widgets/${encodeURIComponent(id)}`).then((d) => d.widget);
}

export function saveWidgetToApi(id, config) {
  return apiJson(`/api/v1/widgets/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify({ config }),
  }).then((d) => d.widget);
}

export function deleteWidgetFromApi(id) {
  return apiJson(`/api/v1/widgets/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function recordWidgetView(id, referer = '') {
  return apiJson(`/api/v1/widgets/${encodeURIComponent(id)}/view`, {
    method: 'POST',
    body: JSON.stringify({ referer }),
  });
}

export function fetchAccountUsage() {
  return apiJson('/api/v1/account');
}

export function updateAccountPlan(planId) {
  return apiJson('/api/v1/account/plan', {
    method: 'POST',
    body: JSON.stringify({ planId }),
  });
}

export function renewAccountPolicies() {
  return apiJson('/api/v1/account/renewal', { method: 'POST' });
}
